
// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";



import { saveAs } from 'file-saver';
// Data
import {loadProcessData} from "../../../applications/data/process_data";
import {useEffect, useState} from "react";
import UserService from "../../../../services/user.service";
import {toast} from "react-toastify";
import ProcessService from "../../../../services/process.service";
import {getPublicURL} from "../../../../services/core.service";
import {getAppPath} from "../../../../services/app-path.service";

function Processes() {
    ////////////////////////////////////////////////////  -> Variable
    let selectedId = "";

    const [hasActivePlan, setHasActivePlan] = useState(true);
    const [planExpiryDate, setPlanExpiryDate] = useState("");
    useEffect(()=>{
     UserService.getPaymentMethod()
        .then((data)=>{
          const hasPlan = data?.data?.data?.["has_active_plan"] === true;
          const renewalDate = data?.data?.data?.["renewal_date"] || "";
          setHasActivePlan(hasPlan);
          setPlanExpiryDate(renewalDate);
          if (hasPlan) {
            localStorage.setItem("has_plan", "1");
          } else {
            localStorage.removeItem("has_plan");
          }
        }).catch((e)=>{
          toast.error(e.response.data.status, {position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000, hideProgressBar: false,});
        })
    }, [])
    const downloadData = (id) =>{
        // let fileName = "Sample Data - Inspection-Test.csv";
        saveAs(getPublicURL() + "processes/raw/" + id, "raw.csv");
    }
    const onClickItem = (event) =>{
        const actionEl = event.target.closest("[data-type]");
        if (!actionEl) {
            return;
        }
        let actionType = actionEl.getAttribute("data-type")
        selectedId = actionEl.getAttribute("data-row")
        // selectedUrl = event.target.getAttribute("data-url")
        // alert(actionType)
        // if (actionType === "delete"){
        //     if (confirm("do you want to delete this process ?"))
        // }else if (actionType === "cancel"){
        //
        // }else
        // alert(actionType)
        if(actionType === "rerun"){
            if (confirm("do you want to rerun this process")){
                 ProcessService.startSimulate(selectedId).
                    then((data)=>{
                        const processStatus = data?.data?.status || data?.data?.Status;
                        if (processStatus === "blocked") {
                            toast.error("Process is blocked. Please log in again or verify your active plan.", {position: toast.POSITION.BOTTOM_RIGHT, autoClose: 3000, hideProgressBar: false});
                            return;
                        }
                        toast.info("process started", {position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000, hideProgressBar: false});
                        setTimeout( function (){
                            window.location.reload();
                        }, 1500);
                  }).catch((e)=>{
                      toast.error(e.response.data.status, {position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000, hideProgressBar: false});
                  });
            }
        }else if(actionType === "download"){
            downloadData(selectedId)
        }else if(actionType === "report"){
            window.location.href = getAppPath("/applications/report?id=" + selectedId)
        }
    }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1}>
              <SoftTypography variant="h5" fontWeight="medium">
                All Processes
              </SoftTypography>
              <SoftTypography variant="button" fontWeight="regular"  color={"error"} >
                Notice: if you don't have an active subscription, your simulation will remain in "Blocked" status
              </SoftTypography>
              {!hasActivePlan && planExpiryDate && (
                <SoftTypography display="block" variant="button" fontWeight="regular" color="warning">
                  Your current plan expired on {planExpiryDate}. Please select a new plan.
                </SoftTypography>
              )}
            </SoftBox>
            <SoftBox display="flex" gap={1}>
              <SoftButton
                size="large"
                color="info"
                component="a"
                href={getAppPath("/applications/new_process")}
                rel="noreferrer"
              >
                Create Process
              </SoftButton>
              <SoftBox variant={"gradient"} sx={{"display":hasActivePlan ? "none" : "block"}}>
                  <SoftButton size={"large"} color={"dark"}  component={"a"} href={getAppPath("/dashboards/pricing")} rel="noreferrer">Select Subscription Now</SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
          <DataTable table={loadProcessData(onClickItem)}
                     entriesPerPage={{defaultValue: 50, entries: [5, 10, 15, 20, 50]}} canSearch isSorted/>
        </Card>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Processes;
